







































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import CpptRanapStore from "@/store/modules/CpptRanapStore";
import Readback from "@/services/Readback";
import { storeDokter } from "@/store/modules/dokter";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import {
  SBAR_COMMUNICATION_OPTIONS,
  SBAR_SECTIONS,
  SBAR_TBAK_STATEMENT,
  SBAR_VERBAL_METHODS,
  SbarSection
} from "@/constants/sbar";
import {
  ReadbackFormValue,
  ReadbackRequest,
  SbarCommunicationMethod,
  SbarSectionKey
} from "@/types/cppt";

function emptySbar(): Record<SbarSectionKey, string | null> {
  return {
    situation: null,
    background: null,
    assessment: null,
    recommendation: null
  };
}

function toDate(value: string | Date | null | undefined): Date | null {
  if (!value) {
    return null;
  }

  return value instanceof Date ? value : moment(value).toDate();
}

function isFilled(value: string | null | undefined): boolean {
  return !!value && value.trim() !== "";
}

@Component({
  components: {
    VCDateTimePicker
  }
})
export default class ReadBackInput extends Vue {
  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean;
  @Prop({ default: null }) readonly value!: ReadbackFormValue | null;
  @Prop({ type: Boolean, default: false }) readonly isActive!: boolean;

  sections = SBAR_SECTIONS;
  communicationOptions = SBAR_COMMUNICATION_OPTIONS;
  tbakStatement = SBAR_TBAK_STATEMENT;

  id: number | null = null;
  unitId: string | null = null;
  reporterLabel: string | null = null;
  reportedAt: Date | null = null;
  communicationMethod: SbarCommunicationMethod | null = null;
  consultantUserId: number | null = null;
  sbar: Record<SbarSectionKey, string | null> = emptySbar();
  hasResponse = false;
  instruction: string | null = null;
  respondedAt: Date | null = null;
  readbackConfirmed = false;
  readbackConfirmedAt: Date | null = null;

  saving = false;
  removing = false;

  get activeUser() {
    return userModule.user;
  }

  get isNakes(): boolean {
    return !!this.activeUser?.is_nakes;
  }

  get registerId(): number {
    return parseInt(this.$route.params.register);
  }

  get pasienRm(): string {
    return this.$route.params.rm;
  }

  get registerDpjpId(): number | null {
    const id = RegisterKunjungan.register?.dokter?.id;

    return id ? Number(id) : null;
  }

  get listDokter() {
    return storeDokter.list.filter(it => it.id != this.activeUser.id);
  }

  get isEdit(): boolean {
    return !!this.id;
  }

  get formLocked(): boolean {
    return this.readonly || !this.isNakes;
  }

  get title(): string {
    return this.isEdit
      ? "Ubah Laporan SBAR / Read Back"
      : "Lapor DPJP (SBAR) / Read Back";
  }

  get reporterName(): string {
    if (this.id) {
      return this.reporterLabel || "-";
    }

    return this.activeUser?.nama || "-";
  }

  get isVerbal(): boolean {
    return (
      !!this.communicationMethod &&
      SBAR_VERBAL_METHODS.includes(this.communicationMethod)
    );
  }

  get responseTime(): Date | null {
    if (this.isVerbal) {
      return this.readbackConfirmed ? this.readbackConfirmedAt : null;
    }

    return this.respondedAt;
  }

  get responseTimeLabel(): string {
    return this.isVerbal
      ? "Tanggal & Jam Konfirmasi TBaK"
      : "Tanggal & Jam Respons DPJP";
  }

  get isSectionOneComplete(): boolean {
    return (
      !!this.reportedAt &&
      !!this.communicationMethod &&
      !!this.consultantUserId &&
      this.sections.every(section => isFilled(this.sbar[section.key]))
    );
  }

  get isResponseComplete(): boolean {
    return (
      this.hasResponse && isFilled(this.instruction) && !!this.responseTime
    );
  }

  get isComplete(): boolean {
    return this.isSectionOneComplete && this.isResponseComplete;
  }

  get footerStatus(): { color: string; text: string } {
    if (!this.isSectionOneComplete) {
      return {
        color: "grey",
        text: "Lengkapi Laporan SBAR (bagian 1) sebelum menyimpan."
      };
    }
    if (this.isComplete) {
      return {
        color: "green",
        text: "Isian lengkap. Siap disimpan & disubmit ke daftar verifikasi DPJP."
      };
    }

    return {
      color: "orange",
      text:
        "Respons / Read Back DPJP belum lengkap. Laporan disimpan sebagai Draft."
    };
  }

  get canRemove(): boolean {
    return this.isEdit && this.isNakes;
  }

  get timeOrderError(): string | null {
    const minute = (d: Date) => moment(d).startOf("minute");
    const now = moment().endOf("minute");

    if (this.reportedAt && minute(this.reportedAt).isAfter(now)) {
      return "Waktu lapor tidak boleh melebihi waktu sekarang.";
    }
    if (!this.isResponseComplete || !this.responseTime) {
      return null;
    }
    if (minute(this.responseTime).isAfter(now)) {
      return `${this.responseTimeLabel} tidak boleh melebihi waktu sekarang.`;
    }
    if (
      this.reportedAt &&
      minute(this.responseTime).isBefore(minute(this.reportedAt))
    ) {
      return `${this.responseTimeLabel} tidak boleh sebelum waktu lapor.`;
    }

    return null;
  }

  get payload(): ReadbackRequest {
    const complete = this.isResponseComplete;

    return {
      register_id: this.registerId,
      pasien_rm: this.pasienRm,
      unit_id: this.id && this.unitId ? this.unitId : this.activeUser.unit_id,
      consulting_at: this.formatDateTime(this.reportedAt),
      communication_method: this.communicationMethod,
      consultant_user_id: this.consultantUserId,
      situation: this.sbar.situation,
      background: this.sbar.background,
      assessment: this.sbar.assessment,
      recommendation: this.sbar.recommendation,
      instruction:
        this.hasResponse && isFilled(this.instruction)
          ? this.instruction
          : null,
      responded_at:
        complete && !this.isVerbal
          ? this.formatDateTime(this.respondedAt)
          : null,
      readback_confirmed_at:
        complete && this.isVerbal
          ? this.formatDateTime(this.readbackConfirmedAt)
          : null
    };
  }

  requiredRule(v: unknown): boolean | string {
    const filled =
      typeof v === "string" ? isFilled(v) : v !== null && v !== undefined;

    return filled || "Wajib diisi";
  }

  sectionStyle(section: SbarSection): Record<string, string> {
    return {
      backgroundColor: `${section.hex}12`,
      borderColor: `${section.hex}47`,
      "--sbar-accent": `${section.hex}66`
    };
  }

  nowDate(): Date {
    return new Date();
  }

  @Watch("value", { deep: true })
  onValueChanged(val: ReadbackFormValue | null) {
    if (!val) {
      this.clearInput();
    } else {
      this.hydrate(val);
    }
  }

  @Watch("hasResponse")
  onHasResponseChanged() {
    this.ensureWrittenResponseTime();
  }

  @Watch("communicationMethod")
  onCommunicationMethodChanged() {
    this.ensureWrittenResponseTime();
  }

  @Watch("readbackConfirmed")
  onReadbackConfirmedChanged(val: boolean) {
    if (!val) {
      this.readbackConfirmedAt = null;
    } else if (!this.readbackConfirmedAt) {
      this.readbackConfirmedAt = new Date();
    }
  }

  @Watch("listDokter")
  onListDokterChanged() {
    if (!this.id && !this.consultantUserId) {
      this.consultantUserId = this.defaultConsultantId();
    }
  }

  mounted() {
    this.clearInput();
  }

  ensureWrittenResponseTime() {
    if (this.hasResponse && !this.isVerbal && !this.respondedAt) {
      this.respondedAt = new Date();
    }
  }

  hydrate(val: ReadbackFormValue) {
    this.id = val.id;
    this.unitId = val.unit_id ?? null;
    this.reporterLabel = val.consulting?.nama ?? null;
    this.reportedAt = toDate(val.consulting_at);
    this.communicationMethod = val.communication_method ?? null;
    this.consultantUserId = Number(val.consultant_user_id) || null;
    this.sbar = {
      situation: val.situation ?? null,
      background: val.background ?? null,
      assessment: val.assessment ?? null,
      recommendation: val.recommendation ?? null
    };
    this.instruction = val.instruction ?? null;
    this.respondedAt = toDate(val.responded_at);
    this.readbackConfirmedAt = toDate(val.readback_confirmed_at);
    this.readbackConfirmed = !!val.readback_confirmed_at;
    this.hasResponse = isFilled(val.instruction) || !!val.responded_at;

    this.$nextTick(() => {
      (this.$refs.form as any)?.resetValidation();
    });
  }

  defaultConsultantId(): number | null {
    const dpjpId = this.registerDpjpId;

    if (!dpjpId || dpjpId === Number(this.activeUser.id)) {
      return null;
    }

    return this.listDokter.some(it => Number(it.id) === dpjpId)
      ? dpjpId
      : null;
  }

  async save() {
    if (this.saving || this.formLocked) {
      return;
    }

    const valid = (this.$refs.form as any)?.validate();

    if (!valid || !this.isSectionOneComplete || this.timeOrderError) {
      appModule.sendErrorAlert(
        this.timeOrderError || "Lengkapi isian Laporan SBAR yang wajib diisi."
      );
      return;
    }

    const complete = this.isComplete;
    this.saving = true;

    try {
      if (this.id) {
        await Readback.update(this.id, this.payload);
      } else {
        await Readback.create(this.payload);
      }

      appModule.sendSuccessNotice(
        complete
          ? "Laporan SBAR tersimpan dan masuk daftar verifikasi DPJP"
          : "Laporan SBAR tersimpan sebagai draft"
      );
      this.clearInput();
      await this.getByRegister();
    } finally {
      this.saving = false;
    }
  }

  async remove() {
    if (this.removing) {
      return;
    }

    this.removing = true;

    try {
      await Readback.destroy(this.id, null);
      this.clearInput();
      await this.getByRegister();
    } catch (err) {
      return;
    } finally {
      this.removing = false;
    }
  }

  removeHandler() {
    if (confirm("Membatalkan laporan SBAR ini?")) {
      this.remove();
    }
  }

  async getByRegister() {
    await CpptRanapStore.getReadbackByRegister(this.registerId);
  }

  clearInput() {
    this.id = null;
    this.unitId = null;
    this.reporterLabel = null;
    this.reportedAt = new Date();
    this.communicationMethod = "telepon";
    this.consultantUserId = this.defaultConsultantId();
    this.sbar = emptySbar();
    this.hasResponse = false;
    this.instruction = null;
    this.respondedAt = null;
    this.readbackConfirmed = false;
    this.readbackConfirmedAt = null;

    this.$nextTick(() => {
      (this.$refs.form as any)?.resetValidation();
    });

    this.$emit("input", null);
  }

  formatDate(date: Date | string | null): string | null {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : null;
  }

  formatDateTime(date: Date | null): string | null {
    return date ? moment(date).format("YYYY-MM-DD HH:mm:00") : null;
  }
}
